import * as React from 'react'

import { SparkleStar } from '../../../../components/sparkle-star'
import type { ToolSlug } from '../../../../lib/content/types'

function VoiceGlyph({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      aria-hidden
      focusable="false"
    >
      <path d="M4 10v4M8 6v12M12 3v18M16 7v10M20 10v4" />
    </svg>
  )
}

function ScissorsGlyph({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <path d="M14.5 4l-9 9M9.5 4l9 9" />
      <circle cx="6" cy="16" r="2.4" />
      <circle cx="18" cy="16" r="2.4" />
    </svg>
  )
}

function ExpandGlyph({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
    </svg>
  )
}

const TOOL_GLYPHS: Record<ToolSlug, React.ComponentType<{ className?: string }>> = {
  'free-tts': VoiceGlyph,
  'free-image': SparkleStar,
  'free-background-remover': ScissorsGlyph,
  'free-upscaler': ExpandGlyph,
}

/** Renders the mockup glyph that represents a given free-tool. */
export function ToolIcon({ slug, className }: { slug: ToolSlug; className?: string }) {
  const Glyph = TOOL_GLYPHS[slug]
  return <Glyph className={className} />
}
